import React, { useEffect, useState } from 'react';
import styles from "../AddOrganisationForm/AddOrganisationForm.module.scss";
import { Field, Formik, FormikProps } from 'formik';
import { Input } from '../common/Input';

import * as yup from 'yup';
import { AssessmentOptions } from '../../apollo/types/AssessmentOptions';
import { FileUpload } from '../common/FileUpload';
import { FormikInput } from '../common/FormikInput';

interface AssessmentsOptionsFormInput {
    formikRef: React.Ref<FormikProps<AssessmentOptions>>;
    submitValues: Function;
    formData?: AssessmentOptions
}


const validationSchema = yup.object().shape({
  assessmentTitle: yup.string().required(),
  assessmentColorPrimary: yup.string().required(),
  assessmentColorSecondary: yup.string().required(),
  assessmentEmailFromName: yup.string().required(),
  assessmentEmailFromAddress: yup.string().email().required(),
  assessmentResultToName: yup.string().required(),
  assessmentResultToAddress: yup.string().email().required(),
  assessmentCopyright: yup.string().required(),
  assessmentSignature: yup.string().required(),
});


export const AssessmentOptionsForm = ({
    formikRef,
    submitValues,
    formData
  }: AssessmentsOptionsFormInput) => {
    const [logo, setLogo] = useState<string|null>(formData?.assessmentLogo ?? null)

  const initialFormValues = {
      assessmentTitle: formData?.assessmentTitle ?? "",
      assessmentColorPrimary: formData?.assessmentColorPrimary ?? "",
      assessmentColorSecondary: formData?.assessmentColorSecondary ?? "",
      assessmentEmailFromName: formData?.assessmentEmailFromName ?? "",
      assessmentEmailFromAddress: formData?.assessmentEmailFromAddress ?? "",
      assessmentResultToName: formData?.assessmentResultToName ?? "",
      assessmentResultToAddress: formData?.assessmentResultToAddress ?? "",
      assessmentCopyright: formData?.assessmentCopyright ?? "",
      assessmentSignature: formData?.assessmentSignature ?? "",
      assessmentAskQuestionsTo: formData?.assessmentAskQuestionsTo ?? "",
      assessmentAskQuestionsLink: formData?.assessmentAskQuestionsLink ?? "",
      assessmentLogo: formData?.assessmentLogo ?? "",
      sendStartMail: formData?.sendStartMail ?? true
  };

  return (
      <Formik
          enableReinitialize
          validationSchema={validationSchema}
          initialValues={initialFormValues}
          onSubmit={(values) => {
              // @ts-ignore
              delete values.id
              // @ts-ignore
              delete values.startMail
              submitValues(values)
          }}
          // @ts-ignore
          innerRef={formikRef}
      >
        {({ values, errors, touched, handleChange, handleSubmit, handleBlur, isValid }) => (
            <form className={styles.formContainer} onSubmit={handleSubmit}>
                {/*{JSON.stringify(errors)}*/}
              <div className={styles.inputContainer}>
                {errors.assessmentTitle && touched.assessmentTitle ? (
                    <span className={styles.error}>Title is required</span>
                ) : null}
                <Field
                    name='assessmentTitle'
                    as={Input}
                    type='text'
                    placeholder='Assessment title'
                    onChange={handleChange}
                    value={values.assessmentTitle}
                />
              </div>
              <div className={styles.inputContainerHalf}>
                  <FormikInput
                      name='assessmentColorPrimary'
                      placeholder='Primary color'
                      errors={errors}
                      touched={touched}
                      onChange={handleChange}
                      value={values.assessmentColorPrimary}
                  ></FormikInput>
                  <FormikInput
                    name='assessmentColorSecondary'
                    placeholder='Secondary color'
                      errors={errors}
                      touched={touched}
                    onChange={handleChange}
                    value={values.assessmentColorSecondary}
                />
              </div>
                <div className={styles.inputContainerHalf}>
                    <FormikInput
                        name='assessmentEmailFromName'
                        errors={errors}
                        touched={touched}
                        placeholder='Email from: Name'
                        onChange={handleChange}
                        value={values.assessmentEmailFromName}
                    />
                    <FormikInput
                        name='assessmentEmailFromAddress'
                       errors={errors}
                      touched={touched}
                        placeholder='Email from: Email Address'
                        onChange={handleChange}
                        value={values.assessmentEmailFromAddress}
                    />
                </div>
                <div className={styles.inputContainerHalf}>
                    <FormikInput
                        name='assessmentResultToName'
                       errors={errors}
                      touched={touched}
                        placeholder='Result to: Name'
                        onChange={handleChange}
                        value={values.assessmentResultToName}
                    />
                    <FormikInput
                        name='assessmentResultToAddress'
                       errors={errors}
                      touched={touched}
                        placeholder='Result to: Email Address'
                        onChange={handleChange}
                        value={values.assessmentResultToAddress}
                    />
                </div>
                <div className={styles.inputContainerHalf}>
                    <FormikInput
                        name='assessmentCopyright'
                       errors={errors}
                      touched={touched}
                        placeholder='Copyright'
                        onChange={handleChange}
                        value={values.assessmentCopyright}
                    />
                    <FormikInput
                        name='assessmentSignature'
                       errors={errors}
                      touched={touched}
                        placeholder='Signature'
                        onChange={handleChange}
                        value={values.assessmentSignature}
                    />
                </div>
                <div className={styles.inputContainerHalf}>
                    <FormikInput
                        name='assessmentAskQuestionsTo'
                       errors={errors}
                      touched={touched}
                        placeholder='Ask questions: Email address'
                        onChange={handleChange}
                        value={values.assessmentAskQuestionsTo}
                    />
                    <FormikInput
                        name='assessmentAskQuestionsLink'
                       errors={errors}
                      touched={touched}
                        placeholder='Ask questions: Link'
                        onChange={handleChange}
                        value={values.assessmentAskQuestionsLink}
                    />
                </div>
                <div className={styles.inputContainer}>
                    <FileUpload label={"Assessment logo"} valueChanged={(value: string) => {
                        values.assessmentLogo = value
                        setLogo(value)
                    }}></FileUpload>
                    {logo &&
                        <div className={styles.logoBlock}>
                            <img src={logo}></img>
                        </div>
                    }
                </div>
            </form>
        )}
      </Formik>
  );
};
